import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core'
import { Subscription } from 'rxjs'

import { AuthenticationService } from '@/services/authentication.service'

import { Store } from '@/domain/store'

@Component({
  selector: 'store-selector',
  templateUrl: './store-selector.component.html'
})
export class StoreSelectorComponent implements OnInit, OnDestroy {

  @Input()
  initialStore: Store = null

  @Output()
  selectedStore = new EventEmitter<Store>()

  selected: Store = null
  stores: Store[] = []
  storeChoice: {}

  private _userDataSubscription: Subscription

  constructor(
    public auth: AuthenticationService
  ) { }

  ngOnInit() {
    // Subscribe to user data changes only, not token-only updates
    this._userDataSubscription = this.auth.userDataChanges$.subscribe(user => {
      if (!user || !user.merchant || !user.merchant.stores) {
        // User logged out or no merchant data
        this.stores = []
        this.selected = null
        this._refresh()
        return
      }

      // Update stores array
      const previousSelectedId = this.selected?.id
      this.stores = user.merchant.stores

      // Try to preserve selection if the store still exists
      if (previousSelectedId) {
        const stillExists = this.stores.find(s => s.id === previousSelectedId)
        if (stillExists) {
          this.selected = stillExists
        } else {
          this.selected = null
        }
      }

      // Apply initial store if provided and nothing selected
      if (this.initialStore && !this.selected) {
        this._init(this.initialStore.id)
      } else {
        this._refresh()
      }
    })
  }

  ngOnDestroy() {
    if (this._userDataSubscription) {
      this._userDataSubscription.unsubscribe()
    }
  }

  classForStore(store: Store): any {
    return store && this.selected && store.id == this.selected.id ? 'btn-info' : 'btn-outline-secondary'
  }

  toggleStore(storeId: number) {
    if (this.selected && storeId == this.selected.id) {
      this.unselect()
    } else {
      this.select(storeId)
    }
  }

  select(storeId: number) {
    this.selected = this.stores.find(s => s.id == storeId)

    if (!this.selected) {
      console.warn('[StoreSelectorComponent] Store not found:', storeId)
      return
    }

    this._refresh()
    this.selectedStore.emit(this.selected)
  }

  unselect() {
    this.selected = null
    this._refresh()
    this.selectedStore.emit(null)
  }

  private _init(storeId: number) {
    this.select(storeId)
  }

  private _refresh(): void {
    this.storeChoice = {}
    this.stores.forEach(s => { this.storeChoice[s.id] = this.selected && this.selected.id == s.id })
  }
}
